import axios from "axios";
import React, { ReactNode, createContext, useState } from "react";
import keys from "../keys.json";
import { toast } from "react-toastify";

// ??______________________________________ CONTACT CONTEXT TYPES _________________________________________?? //
type Props = {
  children: ReactNode;
};

// type ContactFormType = {
//   name: string;
//   email: string;
//   number: string;
//   message: string;
// };

type ContactContextType = {
  // handleSubmitContactForm: (
  //   formObject: ContactFormType,
  //   formRef: HTMLFormElement
  // ) => void;
  loading: boolean;
  handleSubmitSubscribersForm: (email: string) => void;
};

// ??______________________________________ CONTACT CONTEXT PROVIDER _________________________________________?? //
export const ContactContext = createContext<ContactContextType>(
  [] as unknown as ContactContextType
);

export const ContactProvider = ({ children }: Props) => {
  const [loading, setLoading] = useState(false);

  // ??_______________________________ FORM SPREE EMAIL SUBSCRIBERS FUNCTION _______________________________?? //
  const handleSubmitSubscribersForm = async (email: string) => {
    setLoading(true);
    axios
      .post(keys.FORM_SPREE_ENDPOINT, { Email: email })
      .then((response) => {
        toast.success("Thank you for subscribing!");
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Something went wrong. Please try again.");
        setLoading(false);
      });
  };

  // const handleSubmitContactForm = (
  //   formObject: ContactFormType,
  //   formRef: HTMLFormElement
  // ) => {
  //   setLoading(true);

  // ??_______________________________ FORM SPREE _______________________________?? //
  // axios.post(db.FORM_SPREE_ENDPOINT, formObject)
  //   .then((response) => {
  //     console.log('Form submitted successfully');
  //   })
  //   .catch((error) => {
  //     console.error('Error submitting form:', error);
  //   });
  // };

  return (
    <ContactContext.Provider
      value={{
        /*handleSubmitContactForm*/ loading,
        handleSubmitSubscribersForm,
      }}
    >
      {children}
    </ContactContext.Provider>
  );
};
